import { ChecklistItem } from '../components/ChecklistItem';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './ProblemStatementSection.module.css';

const pressures = [
  'Cut a complex portfolio contract mid-cycle, with no one willing to coordinate it.',
  "Validate that every course's AI tool meets FERPA, accessibility, and data-handling requirements — from scratch.",
  'Make inclusive access actually pencil out when textbook bundling is broken.',
  'Tell faculty they now also need to evaluate and administer AI tools on top of their courseware.',
  'Staff cyber-liability reviews for every new ed-tech add-on a department wants.',
  "Maintain accessibility compliance on platforms you don't control.",
] as const;

export function ProblemStatementSection() {
  return (
    <SectionWrapper background="soft" data-testid="institutions-section-problem">
      <div className={styles.layout}>
        <h2 className={styles.title}>
          Higher ed is being asked to solve problems it didn&apos;t sign up to
          solve.
        </h2>
        <ul className={styles.list}>
          {pressures.map((pressure) => (
            <ChecklistItem key={pressure}>{pressure}</ChecklistItem>
          ))}
        </ul>
      </div>
    </SectionWrapper>
  );
}
